export const Permissions = Object.freeze(
    {
        "viewer": "isViewer",
        "editor": "isEditor",
        "publisher": "isPublisher",
        "templateEditor": "isTemplateEditor",
        "admin": "isAdmin",
        "globalViewer": "isGlobalView",
        "globalEditor": "isGlobalEdit",
        "globalAdmin": "isGlobalAdmin",
        "globalSupport": "isGlobalHelp"
    }
);
